import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {FRUtilities} from "#Formulas/FormulaCore/Utilities/FRUtilities";


export class FRBlock extends FRBase{
    private Sentences:FRBase[];
    public ShouldReturn=false;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Sentences=[];
        this.Options.d.forEach(x=>this.Sentences.push(FRFactory.GetFRElement(x,this)));
    }

    Parse(): any {
        let result=null;

        return this.Iterate(this.Sentences,(item,index,onEnd:()=>void)=>{
            result=item;
            if(this.ShouldReturn)
                onEnd();

        },()=>result)

    }

    public ReturnWasExecuted(){
        this.ShouldReturn=true;
        FRUtilities.NotifyReturnToParent(this);
    }

}

FRFactory.AddField('BLO',FRBlock);